import React from "react";
import Header from "../components/Header";
import HeroVideo from "../components/HeroVideo";
import Marquee from "../components/Marquee";
import WelcomeBanner from "../components/WelcomeBanner";
import About from "../components/About";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import ServiceArea from "../components/ServiceArea";
import Testimonials from "../components/Testimonials";
import QuoteForm from "../components/QuoteForm";
import CtaBanner from "../components/CtaBanner";
import Footer from "../components/Footer";
import Seo, { localBusinessLd, websiteLd } from "../components/Seo";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Seo
        title="Termite & Pest Control in South Florida Since 1959"
        description="Dead Bug Edwards is South Florida's family-owned termite and pest control company. Trusted since 1959 across Broward, Miami-Dade & Palm Beach. Call 1-800-DEAD BUG for a free estimate."
        canonical="/"
        jsonLd={[localBusinessLd, websiteLd]}
      />
      <Header />
      <HeroVideo />
      <Marquee />
      <WelcomeBanner />
      <About />
      <Services />
      <CtaBanner />
      <WhyChooseUs />
      <ServiceArea />
      <Testimonials />
      <QuoteForm />
      <Footer />
    </div>
  );
}
